const initialState = {
  eventCommentList: [],
};


export default (state = initialState, action) => {
  switch (action.type) {
    case 'PARSE_COMMENT_LIST':
      return {...state, eventCommentList: action.eventCommentList};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/comment-reducer.js